// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.doc_req_pop[data-v-f4523ae0] {width:910px; height: 600px; overflow-y: scroll;}\n.doc_req_pop > .layer_close[data-v-f4523ae0] {z-index: 10;}\n.div_cntr_area + .div_cntr_area[data-v-f4523ae0] {margin-top: 5px;}\n.text_link[data-v-f4523ae0] {color: #000; padding-left: 2px;}\n.text_link[data-v-f4523ae0]:hover {text-decoration: underline !important;}\n.attdel[data-v-f4523ae0] {cursor: pointer;}\n", ""]);
// Exports
module.exports = exports;
